import React, { Component } from 'react';
import { Row, Col, ProgressBar, Table } from "react-bootstrap";
import Select from 'react-select';
import { toast } from 'react-toastify';

import { CustomCard } from "../../components/Card/CustomCard";
import CustomModal from "../../components/Modal/CustomModal";

import { CarrerasDisp2, SeccionesDisp2 } from "../../funciones/CobranzasFunction";
import { ConsultPeriodos } from '../../funciones/OfertaFunction';
import { CheckCierre, SolicitarToken, CierreInd, FinCierre } from '../../funciones/CierreFunction';

let msjOpen = false;
class Cierre extends Component {
    state = {
        porcentaje: 0,
        tokenCierre: "",
        botonCodigo:{
            icon: "fa fa-envelope",
            text:  "Solicitar",
            disabled: false
        },
        botonCierre:{
            icon: "fa fa-mail-forward",
            text:  "Cerrar",
            disabled: false
        },
        periodoLoad: true,
        periodoDisabled: false,
        periodoSelect: {value: "", label: "- Periodo -"},
        periodos: [],
        carreraLoad: true,
        carreraDisabled: false,
        carreraSelect: {value: "", label: "- Selecciona una Sección -"},
        carreras: [],
        openModalConfirm: false,
        botonConfirm: {
            icon: "fa fa-check",
            text: "Si",
            disabled: false
        },
        displayDiv: "none",
        contentDiv: "",
        openModalToken: false,
        botonToken: {
            icon: "fa fa-check",
            text: "Si",
            disabled: false
        },
        openCierreOk: false
    }

    componentDidMount = () => {
        CarrerasDisp2 ((resp) => {
            this.setState({
                carreras: resp,
                carreraLoad: false
            })
        })

        ConsultPeriodos((resp) => {
            this.setState({
                periodos: resp,
                periodoLoad: false
            })
        })
    }
    
    cambiaPeriodo = (periodoSelect) => {
        this.setState({periodoSelect},() => {
            SeccionesDisp2(periodoSelect.value, (resp) => {
                this.setState({
                    carreras: resp,
                    carreraLoad: false
                })
            })
        })
    }

    cambiaCarrera = (carreraSelect) => {
        this.setState({carreraSelect})
    }

    openModalConfirm = () => {
        const { carreraSelect, periodoSelect, botonCierre, tokenCierre } = this.state;

        if (botonCierre.disabled === true) return null;

        if(periodoSelect.value === ""){
            toast.error("Debes seleccionar primero un Periodo Académico",{autoClose: 4000});
            return null;
        }

        if(carreraSelect.value === ""){
            toast.error("Debes seleccionar una Sección",{autoClose: 4000});
            return null;
        }

        if (tokenCierre === ""){
            toast.error("Debes ingresar un código de seguridad",{autoClose: 4000});
            return null;
        }

        this.setState({
            openModalConfirm: true
        })
    }

    modalCierreOk = () => {
        const { openCierreOk, carreraSelect, periodoSelect, } = this.state;

        if (msjOpen === false) return null;

        let contenido = () => (
            <React.Fragment>
                <div>Se ha cerrado Exitósamente <strong className="text-danger">el Periodo Académico</strong> de <strong>{(carreraSelect.label).replace('CERRAR ', '')}</strong> para el periodo <strong>{periodoSelect.label}</strong>.</div>
            </React.Fragment>
        )

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-check"></i> Ok</React.Fragment>}
                boton1 = ""
                large = "medium"
                isopen =  {openCierreOk}
                titulo = "Cierre Finalizado"
                contenido = {contenido()}
                funcion1 = {() => {this.setState({openCierreOk: false})}}
                funcion2 = {() => {this.setState({openCierreOk: false})}}
            />
        );
    }

    modalConfirm = () => {
        const { botonConfirm, openModalConfirm, carreraSelect, periodoSelect, tokenCierre } = this.state;
        if(carreraSelect.value === "" || periodoSelect.value === "") return null;

        let cierre = () => {
            if (botonConfirm.disabled === true) return null

            this.setState({
                botonConfirm: {
                    icon: "fa fa-spinner fa-spin",
                    text: "Espera",
                    disabled: true
                },
                botonCierre:{
                    icon: "fa fa-spinner fa-spin",
                    text:  "Espera",
                    disabled: true
                },
                botonCodigo:{
                    icon: "fa fa-envelope",
                    text:  "Solicitar",
                    disabled: true
                },
                openModalConfirm: false,
                displayDiv: "block",
                contentDiv: <React.Fragment><i className="fa fa-spinner fa-spin"></i> Comenzando el <strong>Cierre del Periodo Académico</strong>, no salgas de esta ventana ni cierres el navegador.</React.Fragment>,
                periodoDisabled: true,
                carreraDisabled: true,
                openCierreOk: false
            }, () => {
                CheckCierre(tokenCierre, periodoSelect.value, carreraSelect.value, (resp) => {
                    if (resp.status === "Error"){
                        toast.error(resp.mess,{autoClose: 4000});
                        this.setState({
                            botonCodigo:{
                                icon: "fa fa-envelope",
                                text:  "Solicitar",
                                disabled: false
                            },
                            botonCierre:{
                                icon: "fa fa-mail-forward",
                                text:  "Cerrar",
                                disabled: false
                            },
                            botonConfirm: {
                                icon: "fa fa-check",
                                text: "Si",
                                disabled: false
                            },
                            openModalConfirm: false,
                            displayDiv: "none",
                            contentDiv: "",
                            periodoDisabled: false,
                            carreraDisabled: false
                        })
                        
                    }else{
                        let estudiante = (estudiante) => {
                            let nombre2 = "";
                            let apellido2 = "";
                            if (estudiante.nombre_2 !== null) nombre2 = estudiante.nombre_2;
                            if (estudiante.apellido_2 !== null) apellido2 = estudiante.apellido_2;

                            return `${estudiante.nacionalidad}${estudiante.ci} - ${estudiante.nombre_1} ${nombre2} ${estudiante.apellido_1} ${apellido2}`
                        }

                        let cInd = (est, percent, respuesta) => {
                            let slidePercent = 100 / (resp.data.length - 1);
                            CierreInd(resp.data[est].id_estudiante, periodoSelect.value, (resp2) => {
                                if (resp2.status === "warning"){
                                    toast.error(resp2.mess,{autoClose: 6000});
                                }

                                this.setState({
                                    porcentaje: Math.round(percent),
                                    contentDiv: <React.Fragment>
                                                    <i className="fa fa-spinner fa-spin"></i> Se está efectuando el <strong>Cierre del Periodo Académico</strong> de <strong style= {{color:"#000"}}>{estudiante(resp.data[est])}</strong>
                                                    <div style={{marginLeft:22}}>No salgas de esta ventana ni cierres el navegador. Esta operación puede durar varios minutos</div>
                                                </React.Fragment>,
                                }, () => {
                                    if (est === (resp.data.length - 1)){
                                        /* Cierre del periodo de la carrera finalizada */
                                        msjOpen = true;

                                        toast.info("Cierre del periodo de la carrera finalizada",{autoClose: 4000});
                                        this.setState({
                                            botonCodigo:{
                                                icon: "fa fa-envelope",
                                                text:  "Solicitar",
                                                disabled: false
                                            },
                                            botonCierre:{
                                                icon: "fa fa-mail-forward",
                                                text:  "Cerrar",
                                                disabled: false
                                            },
                                            botonConfirm: {
                                                icon: "fa fa-check",
                                                text: "Si",
                                                disabled: false
                                            },
                                            openModalConfirm: false,
                                            displayDiv: "none",
                                            contentDiv: "",
                                            periodoDisabled: false,
                                            carreraDisabled: false,
                                            openCierreOk: true
                                        }, ()=> {
                                            FinCierre(() => {
                                                this.setState({
                                                    porcentaje: 0,
                                                    /* tokenCierre: "", */
                                                })
                                            })
                                        })
                                    }
                                });

                                let estAct = est + 1;
                                let perc = percent + slidePercent;
                                if (estAct <= (resp.data.length - 1)) cInd(estAct, perc, () => {})

                                respuesta(1)
                            })
                        }

                        let ni = 0;
                        if (resp.data.length > 0) {
                            cInd(ni, 0, (resp) => { ni += resp })
                        }else{
                            toast.error("Esta carrera no tiene estudiantes disponibles para el cierre en el periodo seleccionado",{autoClose: 8000});
                            this.setState({
                                botonCodigo:{
                                    icon: "fa fa-envelope",
                                    text:  "Solicitar",
                                    disabled: false
                                },
                                botonCierre:{
                                    icon: "fa fa-mail-forward",
                                    text:  "Cerrar",
                                    disabled: false
                                },
                                botonConfirm: {
                                    icon: "fa fa-check",
                                    text: "Si",
                                    disabled: false
                                },
                                openModalConfirm: false,
                                displayDiv: "none",
                                contentDiv: "",
                                periodoDisabled: false,
                                carreraDisabled: false,
                            })
                        }
                    }
                })
            })
        }

        let contenido = () => (
            <React.Fragment>
                <div>Vas a proceder a <strong className="text-danger">Cerrar el Periodo Académico</strong> de <strong>{(carreraSelect.label).replace('CERRAR ', '')}</strong> para el periodo <strong>{periodoSelect.label}</strong>. No cierres esta ventana ni utilices el sistema hasta que el proceso finalice.</div>
                <div>Su uso indebido puede ocasionar <strong>Fallas al Sistema</strong> y no puede deshacerse.</div>
                <div align="right" className="custom-mt-10"><strong className="text-primary">¿Deseas Continuar?</strong></div>
                <div style={{fontSize:10, marginTop:10}}><strong>Este proceso es de uso delicado y solo debe efectuarse al culminar el periodo y una vez esten cargadas todas las calificaciones.</strong></div>
            </React.Fragment>
        )

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-times"></i> No</React.Fragment>}
                boton1 = {<React.Fragment><i className={botonConfirm.icon}></i> {botonConfirm.text}</React.Fragment>}
                large = "medium"
                isopen =  {openModalConfirm}
                titulo = "Confirmación"
                contenido = {contenido()}      
                funcion1 = {cierre}
                funcion2 = {() => {this.setState({
                    openModalConfirm: false,
                    botonCierre:{
                        icon: "fa fa-mail-forward",
                        text:  "Cerrar",
                        disabled: false
                    },
                    botonConfirm: {
                        icon: "fa fa-check",
                        text: "Si",
                        disabled: false
                    }
                })}}
            />
        );
    }

    modalToken = () => {
        const { openModalToken, botonToken, periodoSelect } = this.state;

        let contenido = () => (
            <React.Fragment>
                <div>¿Deseas enviar un nuevo <strong className="text-danger">Código de Seguridad</strong> al personal autorizado?</div>
                <div style={{fontSize:11}}><strong>Esta acción dejará sin efecto el código anterior</strong></div>
            </React.Fragment>
        )

        let send = () => {
            if (botonToken.disabled === true) return null;

            this.setState({
                botonToken: {
                    icon: "fa fa-spinner fa-spin",
                    text: "Enviando Espera",
                    disabled: true
                },
                botonCodigo:{
                    icon: "fa fa-spinner fa-spin",
                    text:  "Solicitando",
                    disabled: true
                },
            }, () => {
                SolicitarToken(periodoSelect.value, (resp) => {
                    toast[resp.status](resp.mess,{autoClose: 6000});

                    this.setState({
                        openModalToken: false,
                        botonToken: {
                            icon: "fa fa-check",
                            text: "Si",
                            disabled: false
                        },
                        botonCodigo:{
                            icon: "fa fa-envelope",
                            text:  "Solicitar",
                            disabled: false
                        }
                    })
                })
            })
        }

        return(
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-times"></i> No</React.Fragment>}
                boton1 = {<React.Fragment><i className={botonToken.icon}></i> {botonToken.text}</React.Fragment>}
                large = "medium"
                isopen =  {openModalToken}
                titulo = "Confirmación"
                contenido = {contenido()}      
                funcion1 = {send}
                funcion2 = {() => {this.setState({openModalToken: false})}}
            />
        )
    }

    sendCodigo = () => {
        if(this.state.periodoSelect.value === ""){
            toast.error("Debes seleccionar primero un Periodo Académico",{autoClose: 4000});
            return null;
        }

        this.setState({openModalToken: true})
    }

    ayuda = () => (
        <Row>
            <Col md = {12} align="justify">
                En este módulo puedes <strong>Cerrar el Periodo Académico</strong> que has seleccionado. Para eso debes hacer:
            </Col>
            <Col md = {12} align="justify" className="text-primary custom-mt-10"><strong>Paso1:</strong></Col>
            <Col md = {12} align="justify">
                Debes ingresar el <strong className="text-danger">Codigo de Seguridad</strong>.
            </Col>
            <Col md = {12} align="justify">
                Si no lo tienes aún comunicate con Administración o presiona el botón <button className="btn btn-primary btn-xs" style={{borderWidth:1}}><i className="fa fa-envelope"></i> Solicitar</button> para que un nuevo código sea enviado al personal autorizado.
            </Col>
            <Col md = {12} align="justify" className="text-primary custom-mt-10"><strong>Paso2:</strong></Col>
            <Col md = {12} align="justify">
                Una vez ingresado el código, debes seleccionar el <strong>Periodo Actual</strong> y la <strong>Carrera</strong> y presionar el botón  <button className="btn btn-warning btn-xs" style={{borderWidth:1}}><i className="fa fa-mail-forward"></i> Cerrar</button>
            </Col>
            <Col md = {12} align="justify">
                Un mensaje de confirmación aparecerá el cual despues de leerlo atentamente debes presionar <strong>Si</strong>.
            </Col>
            <Col md = {12} align="justify" className="text-primary custom-mt-10"><strong>Paso3:</strong></Col>
            <Col md = {12} align="justify">
                Espera a que la barra termine de cargar al 100%
                <div><ProgressBar now={15} striped style={{height: 12}}/></div>
                y que aparezca el mensaje de afirmación que el proceso ha concluido.
            </Col>
            <Col md = {12} align="justify" className="custom-mt-10">
                <strong>Importante: Este proceso es delicado y una vez que comienza no debe cerrarse la pagina ni cambiar de módulo, de lo contrario podría ocasionar fallas en el sistema.</strong>
            </Col>
        </Row>
    )

    contenido = () => {
        const { porcentaje, botonCodigo, periodoLoad, periodoSelect, periodos, carreraLoad, carreraSelect,
            carreras, botonCierre, displayDiv, contentDiv, periodoDisabled, carreraDisabled, tokenCierre } = this.state;

        return (
            <React.Fragment>
                <div className="custom-alert-info">
                    Cierre del Periodo Académico
                </div>
                <div className="custom-mt-10" style={{padding: 5}}>
                    <div style={{fontSize: 10}} className="text-danger">Progreso</div>
                    <ProgressBar now={porcentaje} striped style={{height: 12}}/>
                    <div align="center" style={{fontSize: 10}}>{parseInt(porcentaje)}%</div>
                </div>
                <div className="custom-alert-info custom-mt-10" style={{padding: 5}}>
                    <Row>
                        <Col md = {12}><strong>Opciones del Cierre</strong></Col>
                        <Col md = {9}>
                            <input type ="password" className="form-control" value = {tokenCierre} onChange={(e) => {this.setState({tokenCierre: (e.target.value).toUpperCase()})}} placeholder="Código de Seguridad"/>
                            <div style={{fontSize: 10}}>Ingresa el Código de Seguridad</div>
                        </Col>
                        <Col md = {3} align = "right">
                            <button className="btn btn-primary" disabled={botonCodigo.disabled} onClick={this.sendCodigo} style={{borderWidth: 1}} title = "Solicitar un nuevo código de seguridad"><i className = {botonCodigo.icon}></i> {botonCodigo.text}</button>
                        </Col>
                    </Row>
                </div>
                <div className="custom-alert-warning custom-mt-10" style={{padding: 5}}>
                    <Row>
                        <Col md = {4}>
                            <Select
                                isDisabled = {periodoDisabled}
                                isLoading = {periodoLoad}
                                isSearchable ={true}
                                value={periodoSelect}
                                onChange={this.cambiaPeriodo}
                                options={periodos}
                            />
                            <div style={{fontSize: 10}}>Periodo Académico</div>
                        </Col>
                        <Col md = {5}>
                            <Select
                                isDisabled = {carreraDisabled}
                                isLoading = {carreraLoad}
                                isSearchable ={true}
                                value={carreraSelect}
                                onChange={this.cambiaCarrera}
                                options={carreras}
                            />
                            <div style={{fontSize: 10}}>Selecciona la Sección</div>
                        </Col>
                        <Col md = {3} align = "right">
                            <button className="btn btn-warning" onClick = {this.openModalConfirm} style={{borderWidth: 1}} title = "Cerrar Periodo Académico"><i className = {botonCierre.icon}></i> {botonCierre.text}</button>
                        </Col>
                    </Row>
                </div>
                <div className="custom-alert-danger custom-mt-10" style={{padding: 5, display: displayDiv, fontSize: 11}}>
                    {contentDiv}
                </div>
            </React.Fragment>
        )
    }

    render() { 
        return (
            <div className="content">
                <Row>
                    <Col md={8}>
                        {this.contenido()}
                    </Col>
                    <Col md={4}>
                        <div style={{borderRadius: "4px 4px",}}>
                            <CustomCard
                                styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                category={<span style={{color: "#fff"}}>Cierre del Periodo Académico</span>}
                                color="#a80012"
                                content={this.ayuda()}
                            />
                        </div>
                    </Col>
                </Row>
                {this.modalConfirm()}
                {this.modalToken()}
                {this.modalCierreOk()}
            </div>
        );
    }
}

export default Cierre;


// WEBPACK FOOTER //
// ./src/views/Academicos/Cierre.jsx